import { TextVariant } from './types';

export const TICKET_CONSTANTS: Record<string, TextVariant> = {
  title: { common: '오프라인 이벤트 참가 정보' },
  numberTitle: { common: '참가자 번호' },
};
